import Vue from "vue";
import Vuex from "vuex";
import tree from "./modules/tree";
import site from "./modules/app-site";
import profile from "./modules/profile";
import application from "./modules/application";
import articleHelper from "./modules/article-helper";
import payments from "./modules/payments";
import education from "./modules/education";
import search from "./modules/search";
import article from "./modules/article";
import icd from "./modules/icd";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    tree,
    profile,
    site,
    application,
    articleHelper,
    payments,
    education,
    search,
    article,
    icd,
  },
});
